"use client";

import { useCallback, useSyncExternalStore } from "react";

const noOnServer = () => false;

/**
 * Whether the viewport is at least `px` wide: false on the server and until
 * hydration, live afterwards (a resize across the line re-renders). The
 * placements that mount only on wide screens (the floating right unit, the
 * in-column one) key on this so a creative is never rendered — and never
 * billed — for a viewport that does not show it.
 */
export function useViewportAtLeast(px: number): boolean {
  const query = `(min-width: ${px}px)`;
  const subscribe = useCallback(
    (onChange: () => void) => {
      const mq = window.matchMedia(query);
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    },
    [query],
  );
  const read = useCallback(() => window.matchMedia(query).matches, [query]);
  return useSyncExternalStore(subscribe, read, noOnServer);
}
